module.exports = __webpack_public_path__ + "img/afee.fb375658.png";